export default __webpack_public_path__ + "static/media/u_multiply-1.336b295b.svg";